import { SettingsResponse } from '@business/entities/settings';
import { BehaviorSubject } from 'rxjs';

export const changed$ = new BehaviorSubject<SettingsResponse | null>(null);

export const get = () => {
  return changed$.value;
};

export const set = (settings: SettingsResponse) => {
  changed$.next(settings);
};

export const clear = () => {
  changed$.next(null);
};

export const current = () => {
  return changed$.value;
};
